import React, { useState } from 'react';
import { isHauptadmin, formatImg } from '../../lib/globalData';
import { useRecordContext, List, Create, Edit, Datagrid, SimpleForm, 
  TextField, ImageField, EditButton, SelectInput, 
  ImageInput } from 'react-admin';
import Move from '../../lib/Move';
import CloseToolbar from '../../lib/CloseToolbar';
import TranslateField from '../../fields/TranslateField';

const artEnumCreate = [
  'bwh.hostel.buchbild',
];

const postDefaultValue = { art: 'bwh.hostel.buchbild', id_element: 1 };

const ListForm = (props) => {
  const MoveCond = (props) => {
    const record = useRecordContext();
    return record && record.art==='bwh.hostel.bild' ? <Move {...props} /> :null;
  };

  const [moveStart, setMoveStart] = useState(0);
  const getMoveStart = () => {
    return moveStart;
  }
  return (
    <List {...props} title={('bw.bwh.image.title')} filter={{ art: 'bwh.hostel.buchbild' }} sort={{ field: 'art', order: 'ASC' }} 
      exporter={isHauptadmin() && props.exporter} perPage={25} >
      <Datagrid style={{ width: 'auto' }} >
        <TranslateField source="art_lbl" />
        <TextField source="id_element" />
        <MoveCond {...props} getMoveStart={getMoveStart} setMoveStart={setMoveStart} endpoint="bwhImage" />
        <ImageField source="text" />
        {isHauptadmin() &&
          <TextField source="id" textAlign="right" />
        }
        <EditButton label="" />
      </Datagrid>
    </List>
  )
}

const CForm = ({hasList, hasEdit, hasCreate, hasShow, ...props}) => {
  const artList = artEnumCreate.map((v)=>{return{id:v,name:'bw.'+v}});
  return (
    <SimpleForm toolbar={<CloseToolbar />} defaultValues={postDefaultValue} {...props}> 
      <SelectInput source="art" choices={artList} defaultValue="bwh.hostel.buchbild" />
      <ImageField source="text" />
      <ImageInput source="text" accept="image/*" format={formatImg} >
        <ImageField source="src" title="text" />
      </ImageInput>
    </SimpleForm>
  )
};

const EForm = ({hasList, hasEdit, hasCreate, hasShow, ...props}) => {
  return (
    <SimpleForm toolbar={<CloseToolbar />} {...props}> 
      <TranslateField source="art_lbl" target="art_lbl_tr" noOutput />
      <TextField source="art_lbl_tr" />
      <TextField source="id_element" />
      <ImageField source="text" />
      <ImageInput source="text" accept="image/*" format={formatImg}>
        <ImageField source="src" title="text" />
      </ImageInput>
    </SimpleForm>
  )
};

const SetImage = {
  list: (props) => (
    <ListForm {...props} />
  ),
  
  create: (props) => (
    <Create {...props} redirect="list" title='bw.bwh.image.titleCreate' >
      <CForm {...props} />
    </Create>
  ),
  
  edit: (props) => (
    <Edit {...props} title='bw.bwh.image.titleEdit' mutationMode="pessimistic" >
      <EForm {...props} />
    </Edit>
  )
}   
export default SetImage